const formatNumberWithCommas = (number, decimalPlaces = 0) => {
  const value = Number(String(number).replace(/,/g, ""));
  if (Number.isNaN(value)) return number;

  const fixedNumber = value.toFixed(decimalPlaces);
  const parts = fixedNumber.toString().split(".");
  parts[0] = parts[0]?.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  return parts.join(".");
};

export const formatUSD = (number) => formatNumberWithCommas(number, 2);

export const formatLBP = (number) => formatNumberWithCommas(number, 0);

export const formatCurrency = (number) => {
  if (!number) return "";

  const value = String(number);

  if (value.includes("USD")) {
    return `$ ${formatUSD(value.replace("USD", ""))}`;
  }

  if (value.includes("$")) {
    return `$ ${formatUSD(value.replace("$", ""))}`;
  }

  if (value.includes("LBP")) {
    return `L.L ${formatLBP(value.replace("LBP", ""))}`;
  }

  if (value.includes("LL") || value.includes("L.L")) {
    return `L.L ${formatLBP(value.replace("LL", "").replace("L.L", ""))}`;
  }

  return value;
};
